import { createApi } from '@reduxjs/toolkit/dist/query/react';
import type IBaseRequest from '../types/Base/BaseRequestInterface';
import { TProcessPaymentRequest, type TResponseGetRequest } from '../types/PaymentsTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const PaymentsApi = createApi({
  reducerPath: 'PaymentsApi',
  tagTypes: ['Payments'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getPayments: build.query<TResponseGetRequest, IBaseRequest>({
      query: (params) => ({
        url: '/trader_payments/',
        params: { page: params?.page || 1, page_size: params?.page_size || 0 },
        method: 'GET',
      }),
    }),
    processPayment: build.mutation({
      query: (body: TProcessPaymentRequest) => ({
        url: '/local_deposit_balance/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetPaymentsQuery, useProcessPaymentMutation } = PaymentsApi;
